/**
 * Binlik ayırıcı (nokta) ve Shopify ondalık fiyat gösterimi.
 * Shopify / API gönderiminde yalnızca rakam + tek ondalık nokta kullanılmalı (örn. 1234.56).
 */

export const stripWholeDigits = (s) => String(s ?? '').replace(/\D/g, '');

/** Binlik nokta; boş giriş → '' */
export const formatThousandsDots = (input) => {
  const raw = stripWholeDigits(input);
  if (!raw) return '';
  const trimmed = raw.replace(/^0+/, '');
  const d = trimmed === '' ? '0' : trimmed;
  const parts = [];
  for (let i = d.length; i > 0; i -= 3) {
    parts.unshift(d.slice(Math.max(0, i - 3), i));
  }
  return parts.join('.');
};

/** parseFloat / API için tam kısım (yalnızca rakamlar) */
export const wholeDigitsForParse = (formattedOrRaw) => {
  const s = stripWholeDigits(formattedOrRaw);
  return s === '' ? '0' : s;
};

/** İmleçten önceki rakam sayısı (biçimli stringde) */
export const countDigitsBeforeCaret = (str, caretPos) => {
  let n = 0;
  const end = Math.min(Math.max(0, caretPos ?? 0), str.length);
  for (let i = 0; i < end; i++) {
    if (/\d/.test(str[i])) n++;
  }
  return n;
};

/** Solda tam olarak `digitsLeft` rakam varken imlecin olması gerektiği index (sonrası) */
export const caretPositionForDigitsLeft = (formatted, digitsLeft) => {
  if (digitsLeft <= 0) return 0;
  let count = 0;
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) {
      count++;
      if (count === digitsLeft) return i + 1;
    }
  }
  return formatted.length;
};

/**
 * Shopify fiyat stringini (örn. "1234.56") tabloda göstermek: "1.234,56"
 */
export const formatShopifyPriceForDisplay = (shopifyPrice) => {
  if (shopifyPrice == null || shopifyPrice === '') return '—';
  const str = String(shopifyPrice).trim();
  if (!str) return '—';
  const parts = str.split('.');
  const intDigits = stripWholeDigits(parts[0]);
  if (intDigits === '' && parts.length === 1) return '0';
  const formattedInt = formatThousandsDots(intDigits === '' ? '0' : intDigits);
  if (parts.length === 1) return formattedInt;
  const frac = (parts[1] || '').replace(/\D/g, '').slice(0, 2).padEnd(2, '0');
  return `${formattedInt},${frac}`;
};
